import React from 'react';
import './Payment.css';

function Payment() {
    return (
        <div className="payment">
            <h1>Payment Page (Work in Progress)</h1>
        </div>
    )
}

export default Payment;
